module.exports = __webpack_public_path__ + "img/t_4.b69cdb12.png";